/**
 * @flow
 * @relayHash 6973e68beb4beb20eb3091684f4eb556
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeletePortfolioAssetInput = {|
  id: string,
  clientMutationId?: ?string,
|};
export type DeletePortfolioAssetMutationVariables = {|
  input: DeletePortfolioAssetInput
|};
export type DeletePortfolioAssetMutationResponse = {|
  +deletePortfolioAsset: ?{|
    +clientMutationId: ?string,
    +isDeleted: ?boolean,
  |}
|};
export type DeletePortfolioAssetMutation = {|
  variables: DeletePortfolioAssetMutationVariables,
  response: DeletePortfolioAssetMutationResponse,
|};
*/


/*
mutation DeletePortfolioAssetMutation(
  $input: DeletePortfolioAssetInput!
) {
  deletePortfolioAsset(input: $input) {
    clientMutationId
    isDeleted
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeletePortfolioAssetInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deletePortfolioAsset",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeletePortfolioAssetPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isDeleted",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeletePortfolioAssetMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeletePortfolioAssetMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeletePortfolioAssetMutation",
    "id": null,
    "text": "mutation DeletePortfolioAssetMutation(\n  $input: DeletePortfolioAssetInput!\n) {\n  deletePortfolioAsset(input: $input) {\n    clientMutationId\n    isDeleted\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'edb68e32cd8fb388dee8fd99a5fcce58';
module.exports = node;
